import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

const config = {
  apiKey: 'AIzaSyD2IQSTK3VvMYEucrDkrRRghGZtSfazEg4',
  authDomain: 'propertyfire-80c2e.firebaseapp.com',
  databaseURL: 'https://propertyfire-80c2e.firebaseio.com',
  projectId: 'propertyfire-80c2e',
  storageBucket: 'propertyfire-80c2e.appspot.com',
  messagingSenderId: '606096176523',
};
firebase.initializeApp(config);

export const db = firebase.firestore();
export const auth = firebase.auth();
export function getUid() {
  return auth.currentUser.uid;
}

db.settings({ timestampsInSnapshots: true });

if (process.env.NODE_ENV === 'development') {
  window.db = db;
}
